import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const SORT_OPTIONS = {
  newest: { label: 'En Yeni', field: 'created_at', dir: -1 },
  oldest: { label: 'En Eski', field: 'created_at', dir: 1 },
  updated: { label: 'Son Güncellenen', field: 'updated_at', dir: -1 },
  name_asc: { label: 'İsme Göre (A-Z)', field: 'name', dir: 1 },
  name_desc: { label: 'İsme Göre (Z-A)', field: 'name', dir: -1 },
  amount_high: { label: 'Tutara Göre (Yüksek)', field: 'amount', dir: -1 },
  amount_low: { label: 'Tutara Göre (Düşük)', field: 'amount', dir: 1 },
};

export const SortSelect = ({ value, onChange, options, customOptions }) => {
  const opts = customOptions || options || ['newest', 'oldest', 'updated', 'name_asc', 'name_desc'];
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-gray-400 whitespace-nowrap">Sırala:</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="bg-gray-800 border-gray-700 text-white text-xs h-8 w-48" data-testid="sort-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-gray-800 border-gray-700 text-white">
          {Array.isArray(opts) && opts[0] && typeof opts[0] === 'object'
            ? opts.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)
            : opts.map(key => <SelectItem key={key} value={key}>{SORT_OPTIONS[key]?.label || key}</SelectItem>)
          }
        </SelectContent>
      </Select>
    </div>
  );
};

// Türkçe karakter normalize
const normTR = (s) => (s || '').toLocaleLowerCase('tr');

// Para değerini sayıya çevir
const parseMoneyValue = (val) => {
  if (!val) return 0;
  const num = parseFloat(String(val).replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.'));
  return isNaN(num) ? 0 : num;
};

// Genel sıralama fonksiyonu
export const sortData = (data, sortKey, nameField, amountField) => {
  const opt = SORT_OPTIONS[sortKey];
  if (!opt) return data;

  return [...data].sort((a, b) => {
    let valA, valB;

    if (opt.field === 'name') {
      valA = normTR(a[nameField]);
      valB = normTR(b[nameField]);
      return opt.dir * valA.localeCompare(valB, 'tr');
    }

    if (opt.field === 'amount') {
      valA = parseMoneyValue(a[amountField]);
      valB = parseMoneyValue(b[amountField]);
      return opt.dir * (valA - valB);
    }

    // Tarih bazlı sıralama
    valA = a[opt.field] || a.created_at || '';
    valB = b[opt.field] || b.created_at || '';
    if (valA < valB) return -1 * opt.dir;
    if (valA > valB) return 1 * opt.dir;
    return 0;
  });
};

// Özel alan sıralama fonksiyonu (customOptions ile kullanılır)
export const sortByField = (data, sortKey, sortDefs) => {
  const def = sortDefs[sortKey];
  if (!def) return data;

  return [...data].sort((a, b) => {
    const dir = def.dir || 1;
    if (def.type === 'number') {
      return dir * ((parseFloat(a[def.field] || 0)) - (parseFloat(b[def.field] || 0)));
    }
    if (def.type === 'money') {
      return dir * (parseMoneyValue(a[def.field]) - parseMoneyValue(b[def.field]));
    }
    if (def.type === 'date') {
      // Boş tarihler sıralamanın sonuna gelsin
      const av = a[def.field];
      const bv = b[def.field];
      const aEmpty = !av || av === '-';
      const bEmpty = !bv || bv === '-';
      if (aEmpty && bEmpty) return 0;
      if (aEmpty) return 1;
      if (bEmpty) return -1;
      const at = new Date(av).getTime();
      const bt = new Date(bv).getTime();
      if (isNaN(at) && isNaN(bt)) return 0;
      if (isNaN(at)) return 1;
      if (isNaN(bt)) return -1;
      return dir * (at - bt);
    }
    // string (varsayılan)
    return dir * normTR(a[def.field]).localeCompare(normTR(b[def.field]), 'tr');
  });
};

export { SORT_OPTIONS };
